import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SetupAccountService {
  constructor(private readonly http: HttpClient) {}

  generateOtp(payload:any): Observable<any>{
    let url = environment.BASE_URL + '/v1/company/email-otp';
    return this.http.post(url, payload);
  }

  verifyOtpStep(payload:any): Observable<any>{
    let url = environment.BASE_URL + '/v1/company/create';
    return this.http.post(url, payload);
  }

  secondryUserAccountSetup(payload:any): Observable<any>{
    let url = environment.BASE_URL + '/v1/auth/generate-setup-otp';
    return this.http.post(url, payload);
  }

  registerSecondryUser(payload:any): Observable<any>{
    let url = environment.BASE_URL + '/v1/auth/setup-password';
    return this.http.post(url, payload);
  }
}
